import './studentAway.css';

// Same text and colour as the tutor's chip in lms-frontend
// (LiveKitMeeting/components/StudentAwayBadge.jsx), so a reviewer watching the
// recording sees exactly what the tutor saw. Tab switch and full screen exit
// both read "Student switched the tab", as they do for the tutor.
const AWAY_LABEL = 'Student switched the tab';
const AWAY_CHIP_COLOR = '#6e1a24';

/**
 * Dims a student tile, flashes its border and pins the chip top-right.
 * The parent must be positioned. Nothing in it is clickable.
 */
const StudentAwayBadge = ({ borderRadius = '8px' }: { borderRadius?: string }) => (
  <div
    className='student-away-overlay'
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 60,
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
      borderRadius,
      pointerEvents: 'none',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      padding: '5px',
    }}
  >
    <div
      style={{
        backgroundColor: AWAY_CHIP_COLOR,
        color: '#e8dcc4',
        padding: '2px 8px',
        borderRadius: '999px',
        fontSize: 'clamp(9px, 0.8vw, 13px)',
        fontWeight: 700,
        lineHeight: 1.4,
        maxWidth: '100%',
        minWidth: 0,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        border: '1px solid rgba(229, 60, 46, 0.55)',
        boxShadow: '0 1px 6px rgba(0, 0, 0, 0.55)',
      }}
    >
      {AWAY_LABEL}
    </div>
  </div>
);

export default StudentAwayBadge;
